import { OPEN_IN_BROWSER_QUERY_PARAM } from '@lentau/seo/shared/sem-redirect-query.constants';

export const STICKY_QUERY_PARAMS: string[] = [OPEN_IN_BROWSER_QUERY_PARAM];
